import { createReducer } from '@reduxjs/toolkit';
import { GetInvoiceDetail, GetReturn, GetReturnItems, PostReturn } from './returnThunk';
const handleAsyncActions = (builder, action, stateKey, errorKey) => {
  builder
    .addCase(action.pending, (state) => {
      state.loading[stateKey] = true; 
      state[stateKey] = null;
      state.error[errorKey] = null;
    })
    .addCase(action.fulfilled, (state, action) => {
      state.loading[stateKey] = false; // Set loading to false when request is fulfilled
      state[stateKey] = action.payload;             
      state.error[errorKey] = null; // Reset error
    })
    .addCase(action.rejected, (state, action) => {
      state.loading[stateKey] = false; // Set loading to false when request fails
      state.error[errorKey] = action.payload; // Set specific error message for the API call
    });
};

const initialState = {
    ReturnList: null,
    ReturnItems:null,
    PostReturnResponse:null,
    InvoiceDetail:null,
  loading: {
    ReturnList: false,
    ReturnItems:false,
    PostReturnResponse:false,
    InvoiceDetail:false,
  },

  error: {
    ReturnListError: null,
    ReturnItemsError:null,
    PostReturnResponseError:null,
    InvoiceDetailError:null,
  },
};

export const ReturnReducer = createReducer(initialState, (builder) => {
//   Use the utility function to handle async actions
 handleAsyncActions(builder, GetReturn, "ReturnList", "ReturnListError");
 handleAsyncActions(builder, GetReturnItems, "ReturnItems", "ReturnItemsError");
 handleAsyncActions(builder, GetInvoiceDetail, "InvoiceDetail", "InvoiceDetailError");
 handleAsyncActions(builder, PostReturn, "PostReturnResponse", "PostReturnResponseError");
});

export default ReturnReducer;